import { HeadCell } from 'shell/components/shared/table/types';
import { PecClient } from 'shell/types/types-pec';

export const authsObj = Object.freeze({});

export const headCells: HeadCell<PecClient, keyof PecClient>[] = [
  {
    id: 'code',
    label: 'N° ID',
  },
  {
    id: 'data',
    label: 'Data e Ora inserimento',
  },
  {
    id: 'typeComunication',
    label: 'Tipo comunicazione',
  },
  {
    id: 'sent',
    label: 'Descrizione destinatario',
    colSpan: 2,
  },
  {
    id: 'object',
    label: 'Oggetto',
    colSpan: 2,
  },
  {
    id: 'message',
    label: 'Messaggio',
    colSpan: 3,
  },
  {
    id: 'dateHour',
    label: 'Data e Ora invio',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'action',
    label: 'Azioni',
    colSpan: 1,
  },
];
